module.exports = __webpack_public_path__ + "img/no-notifications.3f6ce778.jpg";